import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

const SuccessPage = () => {
    const [status, setStatus] = useState('verifying');
    const location = useLocation();

    useEffect(() => {
        const verifyPayment = async () => {
            try {
                const params = new URLSearchParams(location.search);
                const txnid = params.get('txnid');
                
                if (txnid) {
                    // Remove the unused response assignment
                    await api.get(`/payments/verify/${txnid}`);
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            } catch (error) {
                setStatus('error');
            }
        };

        verifyPayment();
    }, [location]);

    return (
        <div className="payment-result">
            {status === 'verifying' && <p>Verifying your payment...</p>}
            {status === 'success' && (
                <div>
                    <h2>Payment Successful! 🎉</h2>
                    <p>Thank you for your donation.</p>
                </div>
            )}
            {status === 'error' && (
                <div>
                    <h2>Payment Verification Failed</h2>
                    <p>Please contact support.</p>
                </div>
            )}
        </div>
    );
};

export default SuccessPage;